export default class LocalStorage {
  static saveToLocalStorage<T>(data: T, id: string): void {
    window.localStorage.setItem(id, JSON.stringify(data));
  }

  static loadFromLocalStorage<T>(id: string): T | undefined {
    const item = window.localStorage.getItem(id);
    if (item === null) {
      return undefined;
    }
    return JSON.parse(item) as T;
  }

  static removeFromLocalStorage(id: string): void {
    window.localStorage.removeItem(id);
  }
}
